import { useEffect, useRef } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";
import {
  documentoConParticipantes,
  participantesParaGuardar,
  vacio,
} from "../utils/borradorParticipantes";

interface Opciones {
  /** Los participantes tal como se van llenando. */
  participantes: any[];
  /** Los documentos de la postulacion, para encontrar al que pertenecen. */
  documentos: any[];
  /** La descripcion del documento en el que van; null si no hay ninguno abierto. */
  descripcion: string | null;
  idPostulacion: any;
  /** Cuanto se espera tras el ultimo cambio antes de guardar. */
  esperaMs?: number;
}

/**
 * Guarda los participantes a medida que se llenan, sin esperar al envio del
 * formulario.
 *
 * Alguien llevaba cuarenta miembros cargados, se le cerro la pagina y perdio
 * todo el trabajo: la lista solo existia en memoria hasta que se enviaba el
 * modal.
 *
 * Se espera un momento tras el ultimo cambio para no escribir en cada tecla, y
 * se usa la ruta que toca un solo documento, no la que reemplaza la columna
 * entera, para no pisar lo que haya en los demas.
 */
export const useBorradorParticipantes = ({
  participantes,
  documentos,
  descripcion,
  idPostulacion,
  esperaMs = 1500,
}: Opciones) => {
  /** Lo ultimo que quedo guardado, para no repetir la misma escritura. */
  const ultimoGuardado = useRef<string>("");

  useEffect(() => {
    if (!descripcion || !idPostulacion) return;
    if (vacio(participantes)) return;

    const foto = JSON.stringify(participantesParaGuardar(participantes));
    if (foto === ultimoGuardado.current) return;

    const temporizador = setTimeout(async () => {
      const documento = (documentos ?? []).find(
        (doc: any) => doc?.descripcion === descripcion
      );
      const conParticipantes = documentoConParticipantes(documento, participantes);
      if (!conParticipantes) return;

      try {
        await apiParticipantes.guardarDocumentoAdministrativo(
          idPostulacion,
          conParticipantes
        );
        ultimoGuardado.current = foto;
      } catch (error) {
        // No se avisa ni se interrumpe: es un respaldo mientras se escribe, y
        // al enviar el formulario se guarda igual.
        console.error("No se pudo guardar el avance de los participantes", error);
      }
    }, esperaMs);

    return () => clearTimeout(temporizador);
  }, [participantes, documentos, descripcion, idPostulacion, esperaMs]);
};
